export enum DocumentRequirement {
  CvCertificateRequired = 'CvCertificateRequired',
  CvRequired = 'CvRequired',
  CertificateRequired = 'CertificateRequired',
  None = 'None',
}
